<div class="form-container mat-elevation-z8">
    <div class="form-group">
      <h3>Unit of Measure</h3>
      <div class="grid-container">
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Primary</mat-label>
            <mat-select [(ngModel)]="primaryMeasure">
              <mat-option value="NRA">NRA</mat-option>
              <mat-option value="NBA">NBA</mat-option>
              <mat-option value="GBA">GBA</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Secondary</mat-label>
            <mat-select [(ngModel)]="secondaryMeasure">
              <mat-option value="NRA">NRA</mat-option>
              <mat-option value="NBA">NBA</mat-option>
              <mat-option value="GBA">GBA</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Tertiary</mat-label>
            <mat-select [(ngModel)]="tertiaryMeasure">
              <mat-option value="NRA">NRA</mat-option>
              <mat-option value="NBA">NBA</mat-option>
              <mat-option value="GBA">GBA</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  
    <div class="form-group">
      <h3>Building Areas</h3>
      <div class="grid-container">
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Gross Building Area (GBA)</mat-label>
            <input matInput placeholder="Placeholder" [(ngModel)]="grossBuildingArea" />
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Gross Leasable Area (GLA)</mat-label>
            <input matInput placeholder="Placeholder" [(ngModel)]="grossLeasableArea" />
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Net Building Area (NBA)</mat-label>
            <input matInput placeholder="Placeholder" [(ngModel)]="netBuildingArea" />
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Usable Building Area (UBA)</mat-label>
            <input matInput placeholder="Placeholder" [(ngModel)]="usableBuildingArea" />
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Net Rentable Area (NRA)</mat-label>
            <input matInput placeholder="Placeholder" [(ngModel)]="netRentableArea" />
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Land to Building (L:B) Ratio</mat-label>
            <input matInput placeholder="Placeholder" [(ngModel)]="landToBuildingRatio" />
          </mat-form-field>
        </div>
      </div>
    </div>
  
    <div class="form-group">
      <h3>Building Details</h3>
      <div class="grid-container">
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Year Built</mat-label>
            <input matInput placeholder="Placeholder" [(ngModel)]="yearBuilt" />
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Year Last Renovated</mat-label>
            <input matInput placeholder="Placeholder" [(ngModel)]="yearLastRenovated" />
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Number of Buildings</mat-label>
            <input matInput placeholder="Placeholder" [(ngModel)]="numberOfBuildings" />
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Number of Stories</mat-label>
            <input matInput placeholder="Placeholder" [(ngModel)]="numberOfStories" />
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Number of Units</mat-label>
            <input matInput placeholder="Placeholder" [(ngModel)]="numberOfUnits" />
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Unit Type</mat-label>
            <mat-select [(ngModel)]="unitType">
              <mat-option value="Type1">Type1</mat-option>
              <mat-option value="Type2">Type2</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  
    <div class="form-group">
      <h3>Construction Details</h3>
      <div class="grid-container">
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Basic Construction</mat-label>
            <mat-select [(ngModel)]="basicConstruction">
              <mat-option value="Type1">Type1</mat-option>
              <mat-option value="Type2">Type2</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Exterior Walls</mat-label>
            <mat-select [(ngModel)]="exteriorWalls">
              <mat-option value="Type1">Type1</mat-option>
              <mat-option value="Type2">Type2</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Roof Type</mat-label>
            <mat-select [(ngModel)]="roofType">
              <mat-option value="Type1">Type1</mat-option>
              <mat-option value="Type2">Type2</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Roof Surface</mat-label>
            <mat-select [(ngModel)]="roofType">
              <mat-option value="Type1">Type1</mat-option>
              <mat-option value="Type2">Type2</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  
    <div class="form-group">
      <h3>Mechanical Details</h3>
      <div class="grid-container">
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Cooling System</mat-label>
            <mat-select [(ngModel)]="coolingSystem">
              <mat-option value="Type1">Type1</mat-option>
              <mat-option value="Type2">Type2</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Fire Protection</mat-label>
            <mat-select [(ngModel)]="fireProtection">
              <mat-option value="Type1">Type1</mat-option>
              <mat-option value="Type2">Type2</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Number of Passenger Elevators</mat-label>
            <input matInput placeholder="Placeholder" [(ngModel)]="numberOfPassengerElevators" />
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Number of Freight Elevators</mat-label>
            <input matInput placeholder="Placeholder" [(ngModel)]="numberOfFreightElevators" />
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Security</mat-label>
            <input matInput placeholder="Placeholder" [(ngModel)]="numberOfFreightElevators" />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  